import React from "react";
import "./pages.css";
import PrintSigLoop from "../components/printSigLoop";

function PrintSignage({ handleLogout, deleteItem, user }) {
  return (
    <>
      <section className="mainSection">
        <nav className="hero">
          <h1 className="sr-only">Print Signage Page</h1>
          <button onClick={handleLogout}>Log Out</button>
        </nav>

        <main>
          <PrintSigLoop deleteItem={deleteItem} user={user} />
        </main>
      </section>
    </>
  );
}

export default PrintSignage;
